import product1 from "./assets/products/1.png";
import product2 from "./assets/products/2.png";
import product3 from "./assets/products/3.png";
import product4 from "./assets/products/4.jpg";
import product5 from "./assets/products/5.png";
import product6 from "./assets/products/6.jpg";
import product7 from "./assets/products/7.jpg";
import product8 from "./assets/products/8.jpg";
import product9 from "./assets/products/9.jpg";

export const PRODUCTS = [
  {
    id: 1,
    productName: "IPhone 12",
    price: 350000,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Macbook Pro 2022 (M1)",
    price: 870000,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Cannon M50 Camera",
    price: 100000,
    productImage: product3,
  },
  {
    id: 4,
    productName: "Itel Black Earbuds",
    price: 7000,
    productImage: product4,
  },
  {
    id: 5,
    productName: "LED Light Strips",
    price: 6000,
    productImage: product5,
  },
  {
    id: 6,
    productName: "HP Foldable Laptop",
    price: 210000,
    productImage: product6,
  },
  {
    id: 7,
    productName: "Iphone X",
    price: 140000,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Edifier Wireless Bluetooth Headphone",
    price: 17500,
    productImage: product8,
  },
  {
    id: 9,
    productName: "IPhone 12 Type Z Charger",
    price: 6500,
    productImage: product9,
  },
];
